import React, { useRef, useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { 
    Container,
    OptionDiv,
    OptionText
 } from './style'

interface StockDropdwonMenu {
  onChange: (value: string) => void
}

const FormatsDropdown: React.FC<StockDropdwonMenu> = (props) => {

  const baseFormats = ["Porcentagem", "Graus", "Nenhum", "Customizado"]

  return (
      <Container onMouseDown={(e) => e.preventDefault()}>
          {baseFormats.map((header, index) => 
            <OptionDiv key={index} onClick={() => props.onChange(header)}>
              <OptionText>{header}</OptionText>
            </OptionDiv>
          )}
      </Container>
  )
}

export default FormatsDropdown